import React, { useState } from 'react';
import Table from '../../../../app/components/Table';
import Pagination from '../../../../app/components/Pagination';
import { FiEdit } from 'react-icons/fi';
import FormEditObligation from '../../../../forms/TaxRegime/FormEditTaxRegime';
import Button from '../../../../app/components/Button';
import { FiPlus } from 'react-icons/fi';
import Toast from '../../../../app/components/Toast';

const TaxObligations = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedObligation, setSelectedObligation] = useState(null);
  const [toast, setToast] = useState({ show: false, type: 'success', message: '' });

  const showToast = (type, message) => {
    setToast({ show: true, type, message });
  };


  const [obligations, setObligations] = useState([
    {
      id: 1,
      nome: 'Declaração de Imposto de Renda',
      obrigacoes: 'Mensal',
      departamentos: 'Fiscal',
      status: 'ativo',
    },
    {
      id: 2,
      nome: 'DCTF',
      obrigacoes: 'Mensal',
      departamentos: 'Contábil',
      status: 'ativo',
    },
    {
      id: 3,
      nome: 'EFD-Contribuições',
      obrigacoes: 'Trimestral',
      departamentos: 'Fiscal',
      status: 'inativo',
    },
    {
      id: 4,
      nome: 'GIA',
      obrigacoes: 'Mensal',
      departamentos: 'Fiscal',
      status: 'ativo',
    },
    {
      id: 5,
      nome: 'EFD-ICMS/IPI',
      obrigacoes: 'Mensal',
      departamentos: 'Fiscal',
      status: 'inativo',
    },
    {
      id: 6,
      nome: 'SINTEGRA',
      obrigacoes: 'Mensal',
      departamentos: 'Fiscal',
      status: 'ativo',
    },
    {
      id: 7,
      nome: 'DeSTDA',
      obrigacoes: 'Anual',
      departamentos: 'Fiscal',
      status: 'ativo',
    },
    {
      id: 8,
      nome: 'SPED Contábil',
      obrigacoes: 'Anual',
      departamentos: 'Contábil',
      status: 'inativo',
    },
    {
      id: 9,
      nome: 'DIRF',
      obrigacoes: 'Anual',
      departamentos: 'Fiscal',
      status: 'ativo',
    },
    {
      id: 10,
      nome: 'DEFIS',
      obrigacoes: 'Anual',
      departamentos: 'Contábil',
      status: 'ativo',
    },
  ]);

  const [filtro] = useState('');
  const [paginaAtual, setPaginaAtual] = useState(1);
  const itensPorPagina = 10;

  const colunas = [
    { titulo: 'ID', campo: 'id' },
    { titulo: 'NOME', campo: 'nome' },
    { titulo: 'OBRIGAÇÕES', campo: 'obrigacoes' },
    { titulo: 'DEPARTAMENTOS', campo: 'departamentos' },
    { titulo: 'AÇÕES', tipo: 'acoes', centralizado: true },
  ];

  const handleEdit = (obligation) => {
    setSelectedObligation(obligation);
    setIsFormOpen(true);
  };

  const handleNewObligation = () => {
    setSelectedObligation(null);
    setIsFormOpen(true);
  };

  const handleFormClose = () => {
    setIsFormOpen(false);
    setSelectedObligation(null);
  };

  const handleFormSubmit = (formData) => {
    if (formData.id) {
      setObligations(obligations.map(obl => 
        obl.id === formData.id ? { ...obl, ...formData } : obl
      ));
      showToast('success', 'Regime editado com sucesso!');
    } else {
      const newId = Math.max(...obligations.map(obl => obl.id), 0) + 1;
      setObligations([...obligations, { ...formData, id: newId, status: 'ativo' }]);
      showToast('success', 'Novo regime cadastrado com sucesso!');
    }

    setIsFormOpen(false);
  };


  const getActionsForObligation = (obligation) => {
    return [
      {
        icon: FiEdit,
        label: 'Editar',
        onClick: () => handleEdit(obligation)
      },
    ];
  };

  const obligationsWithActions = obligations.map(obligation => ({
    ...obligation,
    acoes: getActionsForObligation(obligation)
  }));

  const obligationsFiltrados = filtro 
    ? obligationsWithActions.filter(obligation => 
        obligation.nome.toLowerCase().includes(filtro.toLowerCase()) ||
        obligation.obrigacoes.toLowerCase().includes(filtro.toLowerCase()) ||
        obligation.departamentos.toLowerCase().includes(filtro.toLowerCase())
      )
    : obligationsWithActions;

  const totalPages = Math.ceil(obligationsFiltrados.length / itensPorPagina);
  const indiceInicial = (paginaAtual - 1) * itensPorPagina;
  const indiceFinal = indiceInicial + itensPorPagina;
  const obligationsPaginados = obligationsFiltrados.slice(indiceInicial, indiceFinal);

  const handlePageChange = (page) => {
    setPaginaAtual(page);
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <Button onClick={handleNewObligation}>
          <FiPlus size={17} />
          Cadastrar
        </Button>
        {/*<div className="flex items-center">
          <div className="mr-4">
            <h2 className="text-lg font-medium text-gray-900 flex items-center">
                Regimes Tributários
              <span className="ml-2 bg-gray-200 text-gray-700 text-xs font-medium rounded-full h-5 w-5 flex items-center justify-center">
                {obligations.length}
              </span>
            </h2>
          </div>
        </div>*/}
      </div>

      <div className="overflow-x-auto -mx-3 sm:mx-0">
        <Table 
          colunas={colunas}
          dados={obligationsPaginados}
        />
      </div>

      {obligationsFiltrados.length > 0 && (
        <Pagination 
          currentPage={paginaAtual} 
          totalPages={totalPages} 
          onPageChange={handlePageChange}
          showPageNumbers={true}
          maxPageNumbers={5}
        />
      )}

      <FormEditObligation 
        isOpen={isFormOpen}
        onClose={handleFormClose}
        title={selectedObligation ? "Editar Regime" : "Novo Regime"}
        selectObligation={selectedObligation}
        onSubmit={handleFormSubmit}
      />
      {toast.show && (
        <Toast
          type={toast.type}
          message={toast.message}
          duration={3000}
          onClose={() => setToast({ ...toast, show: false })}
        />
      )}

    </div>
  );
};

export default TaxObligations;